define('TescoMobile_Checkout/js/model/cancelled-order-processor',['Magento_Customer/js/customer-data', 'jquery', 'jquery/jquery-storageapi'], function (customerData, $) {
  'use strict';

  const storage = $.initNamespaceStorage('tm-cancelled-order-message-storage').localStorage;
  return {
    setMessage: function (response) {
      customerData.invalidate(['cart']);
      storage.set('tmOrderCancelledMessage', response.message);
      window.location.reload();
    },
    getMessage: function () {
      return storage.get('tmOrderCancelledMessage');
    },
    clearMessage: function () {
      storage.remove('tmOrderCancelledMessage');
    }
  };
});

